import Carousel from "react-multi-carousel";
import { Suspense } from "react";
import "react-multi-carousel/lib/styles.css";
import { formatDate } from "../../utilities/helper";
import { FaCrown, FaUserPlus } from "react-icons/fa";

const LeaderCard = ({ slides, referral, stylists, moodboard, stylistsworlmedia, images }) => {
    const pairedSlides = [];
    for (let i = 0; i < slides?.length; i += 2) {
        pairedSlides?.push([slides[i], slides[i + 1]]);
    }
    const pairedReferral = [];
    for (let i = 0; i < referral?.length; i += 2) {
        pairedReferral?.push([referral[i], referral[i + 1]]);
    }

    const ButtonGroup = ({ next, previous, carouselState }) => {
        const { currentSlide, slidesToShow, totalItems } = carouselState;
        return (
            <div className="absolute inset-0 flex justify-between items-center px-4 z-10">
                <button
                    onClick={previous}
                    className="w-10 h-10 flex items-center justify-center rounded-full bg-white hover:bg-gray-100 transition"
                >
                    ❮
                </button>
                <button
                    onClick={next}
                    className={`w-10 h-10 flex items-center justify-center rounded-full bg-white hover:bg-gray-100 transition ${currentSlide + slidesToShow >= totalItems
                        ? "opacity-40 cursor-not-allowed"
                        : ""
                        }`}
                >
                    ❯
                </button>
            </div>
        );
    };

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3, // show 3 at a time
            slidesToSlide: 1, // move 1 per swipe
        },
        tablet: {
            breakpoint: { max: 1024, min: 640 },
            items: 2, // show 2 on tablets
            slidesToSlide: 1,
        },
        mobile: {
            breakpoint: { max: 640, min: 0 },
            items: 1, // show 1 on mobile
            slidesToSlide: 1,
        },
    };


    return (

        <Suspense fallback={<></>}>
            <>
                <div className="relative max-w-2xl mx-auto">

                    {stylists && Array.isArray(stylists) && (
                        <Carousel
                            responsive={responsive}
                            swipeable
                            draggable
                            arrows
                            showDots
                            infinite={false}
                            autoPlay
                            autoPlaySpeed={4000}
                            keyBoardControl
                            containerClass="carousel-container"
                            itemClass="px-2"
                        >
                            {stylists?.map((slide, idx) => (
                                <div
                                    key={idx}
                                    className="w-full h-[450px] flex flex-col gap-4 bg-gray-50 dark:bg-gray-800 rounded-lg p-4"
                                >
                                    {/* Image or initials */}
                                    <div className="flex-1 flex items-center justify-center bg-gray-200 dark:bg-gray-600">
                                        {slide?.image ? (
                                            <img
                                                src={slide.image}
                                                alt={slide?.caption}
                                                className="w-full h-full object-cover rounded"
                                            />
                                        ) : (
                                            <span className="text-2xl font-bold text-gray-700 dark:text-gray-200">
                                                {slide?.caption
                                                    ? `${slide?.caption} `
                                                        .split(" ")
                                                        .map((w) => w[0])
                                                        .join("")
                                                        .toUpperCase()
                                                    : "NA"}
                                            </span>
                                        )}
                                    </div>

                                    {/* Details */}
                                    <div className="p-3 bg-white dark:bg-gray-700 rounded-t-none">
                                        <div className="flex items-center gap-2">
                                            {/* <FaCrown className={`w-5 h-5 text-yellow-500`} /> */}
                                            <span className="font-medium text-gray-800 dark:text-white">
                                                {slide?.caption || "-"}
                                            </span>
                                        </div>

                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    )}

                    {moodboard && Array.isArray(moodboard) && (
                        <Carousel
                            additionalTransfrom={0}
                            arrows
                            autoPlay
                            autoPlaySpeed={4000}
                            centerMode={false}
                            className=""
                            containerClass="carousel-container"
                            dotListClass=""
                            draggable
                            focusOnSelect={false}
                            infinite={false}
                            itemClass="px-2"
                            keyBoardControl
                            minimumTouchDrag={80}
                            pauseOnHover
                            renderArrowsWhenDisabled={false}
                            renderButtonGroupOutside={false}
                            renderDotsOutside={false}
                            responsive={{
                                desktop: {
                                    breakpoint: { max: 3000, min: 1024 },
                                    items: 1,
                                },
                                tablet: {
                                    breakpoint: { max: 1024, min: 464 },
                                    items: 1,
                                },
                                mobile: {
                                    breakpoint: { max: 464, min: 0 },
                                    items: 1,
                                },
                            }}
                            rewind={false}
                            rewindWithAnimation={false}
                            rtl={false}
                            shouldResetAutoplay
                            sliderClass=""
                            slidesToSlide={1}
                            swipeable
                        >
                            {moodboard?.map((slide, idx) => (
                                <div
                                    key={idx}
                                    className="w-fit h-full flex flex-col gap-4 bg-gray-50 dark:bg-gray-800 rounded-lg p-4 "
                                >
                                    {/* Image */}
                                    <div className="flex-1 flex items-center justify-center bg-gray-200 dark:bg-gray-600">
                                        {slide?.image ? (
                                            <img
                                                src={slide.image}
                                                alt={slide?.caption}
                                                className="w-full h-full object-cover rounded"
                                            />
                                        ) : (
                                            <span className="text-2xl font-bold text-gray-700 dark:text-gray-200">
                                                {slide?.caption
                                                    ? slide?.caption
                                                        .split(" ")
                                                        .map((w) => w[0])
                                                        .join("")
                                                        .toUpperCase()
                                                    : "NA"}
                                            </span>
                                        )}
                                    </div>

                                    {/* Caption */}
                                    <div className="p-3 bg-white dark:bg-gray-700 rounded-t-none">
                                        <div className="flex items-center gap-2">
                                            <span className="font-medium text-gray-800 dark:text-white">
                                                {slide?.caption || "-"}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    )}


                </div>
                <div className="relative max-w-5xl mx-auto px-4">
                    {referral && Array.isArray(referral) && (
                        <Carousel
                            responsive={responsive}
                            swipeable
                            draggable
                            arrows
                            showDots
                            infinite={false}
                            autoPlay
                            autoPlaySpeed={4000}
                            keyBoardControl
                            containerClass="carousel-container"
                            itemClass="px-2"
                        >
                            {/* {referral && Array?.isArray(referral) &&
                        referral?.map((referral, idx) => ( */}
                            {referral?.map((referral, idx) => (
                                <div
                                    key={idx}
                                    className="w-full h-[450px] flex flex-col gap-4 bg-gray-50 dark:bg-gray-800 rounded-lg p-4"
                                >

                                    <div className="flex-1 flex items-center justify-center bg-gray-200 dark:bg-gray-600 ">
                                        {referral?.image ? (
                                            <img
                                                src={referral.image}
                                                alt={referral.displayName}
                                                className="w-full h-full object-cover gap-4"
                                            />
                                        ) : (
                                            <span className="text-2xl font-bold text-gray-700 dark:text-gray-200">
                                                {referral?.firstName
                                                    ? `${referral.firstName} ${referral.lastName}`
                                                        .split(" ")
                                                        .map((w) => w[0])
                                                        .join("")
                                                        .toUpperCase()
                                                    : "NA"}
                                            </span>
                                        )}
                                    </div>
                                    <div className="p-3 bg-white dark:bg-gray-700 rounded-t-none">
                                        <div className="flex items-center gap-2">
                                            <FaUserPlus className="w-5 h-5 text-yellow-500" />
                                            <span className="font-medium text-gray-800 dark:text-white">
                                                {`${referral?.firstName} ${referral?.lastName}`}
                                            </span>
                                        </div>
                                        <p className="text-sm text-gray-600 dark:text-gray-300">
                                            Email: {referral?.email}
                                        </p>
                                        <p className="text-sm text-gray-600 dark:text-gray-300">
                                            Referral Code: {referral?.refCode}
                                        </p>
                                        <p className="text-sm text-gray-600 dark:text-gray-300">
                                            Created At: {referral?.createdAt ? formatDate(referral?.createdAt) : "-"}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    )}
                    {slides && Array.isArray(slides) && (
                        <Carousel
                            responsive={responsive}
                            swipeable
                            draggable
                            arrows
                            showDots
                            infinite={false}
                            autoPlay
                            autoPlaySpeed={4000}
                            keyBoardControl
                            containerClass="carousel-container"
                            itemClass="px-2"
                        >
                            {slides?.map((slide, idx) => (
                                <div
                                    key={idx}
                                    className="w-full h-[450px] flex flex-col gap-4 bg-gray-50 dark:bg-gray-800 rounded-lg p-4"
                                >
                                    {/* Image or initials */}
                                    <div className="flex-1 flex items-center justify-center bg-gray-200 dark:bg-gray-600">
                                        {slide?.image ? (
                                            <img
                                                src={slide.image}
                                                alt={slide.displayName}
                                                className="w-full h-full object-cover rounded"
                                            />
                                        ) : (
                                            <span className="text-2xl font-bold text-gray-700 dark:text-gray-200">
                                                {slide?.displayName
                                                    ? `${slide?.displayName} `
                                                        .split(" ")
                                                        .map((w) => w[0])
                                                        .join("")
                                                        .toUpperCase()
                                                    : "NA"}
                                            </span>
                                        )}
                                    </div>

                                    {/* Details */}
                                    <div className="p-3 bg-white dark:bg-gray-700 rounded-t-none">
                                        <div className="flex items-center gap-2">
                                            <FaCrown className={`w-5 h-5 text-yellow-500`} />
                                            <span className="font-medium text-gray-800 dark:text-white">
                                                {slide?.displayName || "-"}
                                            </span>
                                        </div>
                                        
                                        {/* <p className="text-sm text-gray-600 dark:text-gray-300">
                                                   Name: {stylist?.displayName}
                                               </p> */}
                                        <p className="text-sm text-gray-600 dark:text-gray-300">
                                            Matches: {slide?.matches}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    )}
                    {stylistsworlmedia && Array.isArray(stylistsworlmedia) && (
                        <Carousel
                            responsive={{
                                desktop: {
                                    breakpoint: { max: 3000, min: 1024 },
                                    items: 3, 
                                    slidesToSlide: 1,
                                },
                                tablet: {
                                    breakpoint: { max: 1024, min: 640 },
                                    items: 2, 
                                    slidesToSlide: 1,
                                },
                                mobile: {
                                    breakpoint: { max: 640, min: 0 },
                                    items: 1, 
                                    slidesToSlide: 1,
                                },
                            }}
                            swipeable
                            draggable
                            arrows
                            showDots
                            infinite={false}
                            autoPlay
                            autoPlaySpeed={4000}
                            keyBoardControl
                            rewind
                            containerClass="carousel-container"
                            itemClass="px-2"
                        >
                            {stylistsworlmedia?.map((slide, idx) => (
                                <div
                                    key={idx}
                                    className="w-full h-[450px] flex flex-col gap-4 bg-gray-50 dark:bg-gray-800 rounded-lg p-4 "
                                >
                                    {/* Image or initials */}
                                    <div className="flex-1 flex items-center justify-center bg-gray-200 dark:bg-gray-600">
                                        {slide?.image ? (
                                            <img
                                                src={slide.image}
                                                alt={slide?.caption}
                                                className="w-full h-full object-cover rounded"
                                            />
                                        ) : (
                                            <span className="text-2xl font-bold text-gray-700 dark:text-gray-200">
                                                {slide?.caption
                                                    ? slide?.caption
                                                        .split(" ")
                                                        .map((w) => w[0])
                                                        .join("")
                                                        .toUpperCase()
                                                    : "NA"}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    )}
                </div>
                  <div className="relative max-w-lg">
                     {images && Array.isArray(images) && (
                        <Carousel
                             responsive={{
                                desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
                                tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
                                mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
                            }}
                            swipeable
                            draggable
                            arrows
                            showDots
                            infinite={false}
                            autoPlay
                            autoPlaySpeed={4000}
                            keyBoardControl
                            rewind
                            containerClass="carousel-container"
                            itemClass="px-"
                        >
                              {images?.map((d, idx) => (
                                <div
                                    key={idx}
                                    className="w-full h-[450px] flex flex-col bg-gray-50 dark:bg-gray-800 rounded-lg p-1 "
                                >
                                    <div className="flex-1 flex items-center justify-center bg-gray-200 dark:bg-gray-600">
                                        <img src={d} alt={`slide-${idx}`} className="w-full h-full object-cover rounded"/>
                                        
                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    )}
                  </div>
               
                {/* Stylist Profile Image */}
                {/* <div className="relative max-w-lg">
                    {images && Array.isArray(images) && (
                        <Carousel
                            responsive={{
                                desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
                                tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
                                mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
                            }}
                            swipeable
                            draggable
                            arrows
                            // customButtonGroup={<ButtonGroup />}
                            renderButtonGroupOutside={true}
                            slidesToSlide={1}
                            
                            showDots={true}
                            renderDotsOutside={true}
                            ssr={true}
                            infinite={false}
                            autoPlay={true}
                            autoPlaySpeed={4000}
                            dotListClass=""
                            keyBoardControl={true}
                            rewind
                            containerClass="carousel-container"
                            itemClass="carousel-item"
                            rewindWithAnimation={false}
                        >
                            
                            {images?.map((d, idx) => (
                                <div
                                    key={idx}
                                    className="w-full  flex flex-col gap- bg-gray-50 dark:bg-gray-800 rounded-lg p-"
                                    // className="w-full h-[350px] md:h-[310px] lg:h-[350px] flex items-center justify-center bg-gray-100 rounded-lg overflow-hidden"
                                >
                                    <img src={d} alt={`slide-${idx}`} className=" object-contain" />
                                </div>
                            ))}
                        </Carousel>
                    )}
                </div> */}
            </>
        </Suspense>

    )
};

export default LeaderCard;